<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  ::v-deep .popper[x-placement^="top"] .popper__arrow {
    border-color: $salesflow-bg-content transparent transparent transparent;
  }

  ::v-deep .popper[x-placement^="bottom"] .popper__arrow {
    border-color: transparent transparent $salesflow-bg-content transparent;
  }

  .assign-text {
    line-height: 190%;
    font-weight: 500;
    font-size: 0.75rem;
  }
  .activity-followers {
    margin: 0;
    font-size: inherit;

    .editable-modal {
      z-index: 10;
      display: flex;
      min-width: 170px;
      text-align: left;
      padding: 16px;
      border-radius: 16px;
      background-color: $salesflow-bg-content;
      flex-direction: column;
      box-shadow: 0 5px 15px rgba(0, 0, 0, .3);

      .editable-content {
        margin-top: 10px;

        .input-group-text {
          border: none;
          border-radius: 0;
          background: #fff;
          padding: 0.375rem 1.2rem;
          background-color: #e9ecef;
        }

        .form-control,
        .input-group-text {
          margin-bottom: 10px;
        }

        input.form-control {
          height: auto;
          border: 1px solid $salesflow-outline-gray-medium;
          border-radius: 8px;
          background-color:white;
          width: 100%;
          padding: 1rem 0.75rem;
          @include salesflow-text;
          text-align: start;

          &::placeholder {
            color: $salesflow-outline-gray-medium;
          }
        }

        button {
          margin: 5px auto 0;
        }

        ul {
          overflow-y: auto;
          max-height: 26vh;
          padding: 0;
          margin: 0;

          &::-webkit-scrollbar {
            width: 4px;
            border-radius: 30px;
          }

          &::-webkit-scrollbar-thumb {
            background: #ccc6d6;
            border-radius: 30px;
          }
        }

        .user-list {
          display: flex;
          align-items: baseline;
          padding: 5px;
          border-radius: 5px;
          font-size: 12px;

          .user-list-item {
            display: inline-block;
            margin-right: 6px;
          }

          .user-list-check {
            margin-left: auto;

            i {
              vertical-align: sub;
            }
          }

          .initials {
            display: flex;
          }

          &:hover {
            color: $salesflow-font-dark;
            background: $salesflow-outline-gray-light;
          }
        }
      }
    }

    button {
      font-size: inherit;
      font-weight: 500;
      letter-spacing: -0.18px;
      color: inherit;

      p {
        text-decoration: underline;
      }

      svg {
        margin-bottom: 3px;
        margin-right: 5px;
      }

      &:hover {
        background: transparent;
      }
    }

    .users-wrapper {
      .circle {
        margin: 0 0 0 5px;

        &:first-child {
          margin: 0 0 0 3px;
        }
      }

      p {
        font-size: 10px;
      }
    }

    &.without-put {
      margin-left: 10px;
    }

    &:not(.without-put) {
      display: inline;

      .users-wrapper {
        display: inline;
        margin-left: 6px !important;
      }
    }
  }
</style>

<template>
  <div
    class="activity-followers"
    :class="{ pointer: can && hasMinUsers }"
    @click.prevent="toggleModal()"
    v-show="users"
  >
    <Popper
      trigger="click"
      :options="popper.options"
    >
      <div class="popper editable-modal">
        <div class="editable-content">
          <div class="form-group">
            <input
              class="form-control"
              type="text"
              :placeholder="__('Encontrar usuário')"
              v-model="query"
            >
          </div>
          <ul>
            <li
              class="pointer user-list"
              v-for="maybeActive in usersByName"
              @click.prevent="_toggleActive(maybeActive.id)"
            >
              <span class="user-list-item">
                <Avatar
                  class="circle avatar"
                  width="30"
                  :name="maybeActive.name"
                  :url="maybeActive.gravatar"
                  :key="maybeActive.id"
                /></span><span class="user-list-item">{{ maybeActive.name }}</span><span class="user-list-check">
                  <IconCheck
                    color="#212529"
                    size="10"
                    v-show="isActive(maybeActive.id)"
                  />
                </span>
            </li>
            <li
              class="user-list"
              v-if="usersByName.length == 0"
            >
              {{ __('Nenhum usuário encontrado') }}
            </li>
          </ul>
        </div>
      </div>
      <button
        class="btn btn-sm text-decoration-none"
        :class="btnCustomClass"
        slot="reference"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11"
          height="11"
          viewbox="0 0 11 11"
          v-if="smallIcon"
        >
          <g>
            <g>
              <g>
                <path
                  fill="#857a98"
                  d="M5.2 1.678c.97 0 1.763.793 1.763 1.763 0 .97-.794 1.763-1.763 1.763-.97 0-1.763-.793-1.763-1.763 0-.97.793-1.763 1.763-1.763zm0 4.158A2.395 2.395 0 0 0 7.595 3.44 2.39 2.39 0 0 0 5.2 1.054 2.394 2.394 0 0 0 2.805 3.44 2.4 2.4 0 0 0 5.2 5.836z"
                />
                <path
                  fill="none"
                  stroke="#857a98"
                  stroke-miterlimit="50"
                  stroke-width=".2"
                  d="M5.2 1.678c.97 0 1.763.793 1.763 1.763 0 .97-.794 1.763-1.763 1.763-.97 0-1.763-.793-1.763-1.763 0-.97.793-1.763 1.763-1.763zm0 4.158A2.395 2.395 0 0 0 7.595 3.44 2.39 2.39 0 0 0 5.2 1.054 2.394 2.394 0 0 0 2.805 3.44 2.4 2.4 0 0 0 5.2 5.836z"
                />
              </g>
              <g>
                <path
                  fill="#857a98"
                  d="M6.684 6.886c1.204 0 2.196.897 2.35 2.057h-7.64a2.378 2.378 0 0 1 2.351-2.057zm-5.628 2.69h8.316c.177 0 .316-.14.316-.317a3.008 3.008 0 0 0-3.004-3.004H3.745A3.008 3.008 0 0 0 .741 9.259c0 .177.14.316.315.316z"
                />
                <path
                  fill="none"
                  stroke="#857a98"
                  stroke-miterlimit="50"
                  stroke-width=".2"
                  d="M6.684 6.886c1.204 0 2.196.897 2.35 2.057h-7.64a2.378 2.378 0 0 1 2.351-2.057zm-5.628 2.69h8.316c.177 0 .316-.14.316-.317a3.008 3.008 0 0 0-3.004-3.004H3.745A3.008 3.008 0 0 0 .741 9.259c0 .177.14.316.315.316z"
                />
              </g>
            </g>
          </g>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="17"
          viewbox="0 0 18 17"
          v-else
        >
          <g>
            <g>
              <g>
                <path
                  fill="#3b334a"
                  d="M9.094 2.1a3.113 3.113 0 0 1 3.103 3.103 3.113 3.113 0 0 1-3.103 3.103A3.113 3.113 0 0 1 5.99 5.203a3.113 3.113 0 0 1 3.104-3.104zm0 7.318a4.216 4.216 0 0 0 4.215-4.215A4.205 4.205 0 0 0 9.094 1a4.214 4.214 0 0 0-4.216 4.203 4.225 4.225 0 0 0 4.216 4.215z"
                />
                <path
                  fill="none"
                  stroke="#3b334a"
                  stroke-miterlimit="50"
                  stroke-width=".2"
                  d="M9.094 2.1a3.113 3.113 0 0 1 3.103 3.103 3.113 3.113 0 0 1-3.103 3.103A3.113 3.113 0 0 1 5.99 5.203a3.113 3.113 0 0 1 3.104-3.104zm0 7.318a4.216 4.216 0 0 0 4.215-4.215A4.205 4.205 0 0 0 9.094 1a4.214 4.214 0 0 0-4.216 4.203 4.225 4.225 0 0 0 4.216 4.215z"
                />
              </g>
              <g>
                <path
                  fill="#3b334a"
                  d="M11.706 11.267a4.174 4.174 0 0 1 4.138 3.62H2.395a4.185 4.185 0 0 1 4.138-3.62zM1.8 16h14.637c.31 0 .557-.246.557-.556a5.295 5.295 0 0 0-5.29-5.289H6.534a5.295 5.295 0 0 0-5.288 5.289c0 .31.245.556.556.556z"
                />
                <path
                  fill="none"
                  stroke="#3b334a"
                  stroke-miterlimit="50"
                  stroke-width=".2"
                  d="M11.706 11.267a4.174 4.174 0 0 1 4.138 3.62H2.395a4.185 4.185 0 0 1 4.138-3.62zM1.8 16h14.637c.31 0 .557-.246.557-.556a5.295 5.295 0 0 0-5.29-5.289H6.534a5.295 5.295 0 0 0-5.288 5.289c0 .31.245.556.556.556z"
                />
              </g>
            </g>
          </g>
        </svg><span
          class="assign-text d-inline mr-2 text-decoration-underline"
          v-if="hasActives"
        >{{ __('Atribuir') }}</span><span
          class="d-inline mr-2 text-decoration-underline"
          v-else
        >{{ __('Atribuir a dono') }}</span>
        <Avatar
          class="circle user d-inline-flex avatar-tiny"
          width="15"
          v-b-tooltip.top="user.name"
          :name="user.name"
          :url="user.gravatar"
          :key="user.id"
          v-for="user in publicUsers"
        />
      </button>
    </Popper>
    <div v-if="loading">
      <i class="fa fa-circle-o-notch fa-spin" />
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import Popper from 'vue-popperjs';
import User from '../user/Users.vue';
import 'vue-popperjs/dist/vue-popper.css';

export default {
  components: {
    Popper,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  extends: User,

  props: {
    lead: '',
    activity: '',
    btnCustomClass: '',
    smallIcon: {
      type: Boolean,
      default: false,
    },
    put: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      errors: {
        addUser: this.__('Falha em adicionar follower.'),
        removeUser: this.__('Falha em remover follower.'),
      },
      popper: {
        options: {
          modifiers: {
            offset: { offset: '84px,0px' },
          },
        },
      },
    };
  },

  mounted () {
    this.$emit('input', this.actives);

    if (this.users.length) {
      this.loading = false;
    }
  },

  watch: {
    allUsers(users) {
      if (users) {
        this.loading = false;
      }
    },
  },

  methods: {
    _toggleActive (id) {
      this.toggleActive(id).then((actives) => this.$emit('input', actives));
    },

    store (id) {
      if (this.put) {
        return this.$http.put(`/lead/${this.lead}/activity/${this.activity}`, { toggle: id });
      }

      return new Promise((resolve) => resolve());
    },
  },
};
</script>
